export
const name: string = "CPlane";

export
const preproc: string = ``;

export
const declaration: string = ``;

export
const varyings: string = `
    varying vec3 v_plane_position;
`;

export
const implementation: string = `
    /**
     * @param aModelPosition modelMatrix * (a_position, 1.0)
     */
    void setVaryingsForCPlane(in vec4 aModelPosition)
    {
        v_plane_position = aModelPosition.xyz / aModelPosition.w;
    }
`;
